import { Autocomplete, TableOrderByType, Tooltip, Icon as HarfangIcon } from '@elipssolution/harfang';
import { mdiInformation } from '@mdi/js';
import { Stack } from '@mui/material';

import useFormat from '../../../../hooks/useFormat';
import { TagType } from '../../types/tag';

type TagAutocompleteProps = {
	dataSource: (
		limit: number,
		offset: number,
		search?: string,
		orderBy?: TableOrderByType<TagType>,
	) => Promise<{
		count: number;
		items: TagType[];
	}>;
	disabled?: boolean;
	onChange: (value?: TagType) => void;
	value?: TagType;
};

const TagAutocomplete = ({ dataSource, disabled, onChange, value }: TagAutocompleteProps) => {
	const { isMobileFormat } = useFormat();

	const optionsRenderer = (option: TagType, displayedValue: JSX.Element) => (
		<Stack flexDirection="row" justifyContent="space-between" alignItems="center" width="100%">
			{displayedValue}

			{option.info && !isMobileFormat && (
				<Tooltip content={option.info}>
					<HarfangIcon path={mdiInformation} />
				</Tooltip>
			)}
		</Stack>
	);

	return (
		<Autocomplete<TagType>
			dataSource={dataSource}
			disabled={disabled}
			getOptionLabel={({ name }) => name}
			renderOptions={optionsRenderer}
			onChange={onChange}
			optionWidth={isMobileFormat ? undefined : 300}
			placeholder="Tag"
			value={value}
			disableClearable
		/>
	);
};

export default TagAutocomplete;
